<template>
  <b-row
    :class="customChange ? 'list-group-item' : ''"
  >
    <b-col
      md="12"
      xl="12"
    >
      <b-overlay
        id="overlay-background-documents"
        :show="paymentsLoader"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-card>
          <b-card-header
            class="base-document-header"
          >
            <b-card-title>{{ $t('DEBTIA_PAYMENTS') }}</b-card-title>
            <b-card-title class="text-primary">
              <!-- <drag-links
                :parent="3"
                :side="side"
                :custom-change="customChange"
              /> -->
            </b-card-title>
          </b-card-header>
          <b-table
            v-if="paymentsData.length > 0"
            :fields="paymentsTableFields"
            :items="paymentsData"
            :tbody-tr-class="paymentRowClass"
            striped
            responsive
            hover
            @row-clicked="onPaymentRowClicked"
          >
            <template #cell(id)="row">
              {{ row.item.type === 'Local' ? row.item.id : row.item.paymentIDNo }}
            </template>
            <template #cell(Amount)="row">
              {{ getDKKConvertedAmount(row.item.Amount) }}
            </template>
            <!-- <template #cell(remainingAmount)="row">
              {{ getDKKConvertedAmount(row.item.remainingAmount) }}
            </template> -->
            <template #cell(type)="row">
              {{ row.item.type === 'Local' ? $t('DEBTIA_PAID_TO_CLIENT') : $t('DEBTIA_PAID_TO_US') }}
            </template>
            <template #row-details="row">
              <b-card
                class="mt-2 border-primary"
              >
                <b-card-title class="h6 mb-2">
                  {{ $t('DEBTIA_PAYMENT_STATEMENTS_DISTRIBUTION') }}
                </b-card-title>
                <template v-if="statementLinesFor(row.item).length > 0">
                  <b-table
                    :fields="allocationLogFields"
                    :items="statementLinesFor(row.item)"
                    small
                    striped
                    responsive
                    class="mb-2"
                  />
                  <b-alert
                    v-if="row.item.type === 'Local' && hasVatReceiptAmount(row.item)"
                    variant="warning"
                    show
                  >
                    <div class="alert-body">
                      {{ $t('DEBTIA_PAYMENT_DIRECT_TO_CLIENT_COST_INVOICE') }}
                    </div>
                  </b-alert>
                  <b-button
                    v-else-if="hasVatReceiptAmount(row.item)"
                    variant="primary"
                    size="sm"
                    :disabled="!canDownloadFor(row.item) || pdfDownloadRowKey === rowKey(row.item)"
                    @click.stop.prevent="downloadAllocationPdf(row.item)"
                  >
                    <b-spinner
                      v-if="pdfDownloadRowKey === rowKey(row.item)"
                      small
                      class="mr-1"
                    />
                    {{ $t('DEBTIA_DOWNLOAD_PAYMENT_BREAKDOWN_PDF') }}
                  </b-button>
                  <b-alert
                    v-else
                    variant="warning"
                    show
                  >
                    <div class="alert-body">
                      {{ $t('DEBT_NO_VAT_RECIEPT') }}
                    </div>
                  </b-alert>
                </template>
                <b-alert
                  v-else
                  variant="warning"
                  show
                >
                  <div class="alert-body">
                    {{ $t('DEBTIA_NO_PAYMENT_DISTRIBUTION') }}
                  </div>
                </b-alert>
              </b-card>
            </template>
          </b-table>
          <b-alert
            v-else
            variant="warning"
            show
          >
            <div class="alert-body">
              {{ $t('DEBTIA_NO_PAYMENTS_MSG') }}
            </div>
          </b-alert>
        </b-card>
      </b-overlay>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BCard, BAlert, BTable, BCardHeader, BCardTitle, BOverlay, BButton, BSpinner,
} from 'bootstrap-vue'
// import store from '@/store'
import axios from '@axios'
import { EventBus } from '@/event-bus'
import constants from '@/app-configs/constants'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Ripple from 'vue-ripple-directive'
import i18n from '@/libs/i18n'
// import DragLinks from '../DragLinks.vue'

// Bootstrap-Vue row-details flag (literal name required by the library).
const SHOW_DETAILS_KEY = '_showDetails'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BAlert,
    BTable,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    BCardHeader,
    BCardTitle,
    BOverlay,
    BButton,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  props: {
    side: {
      type: String,
      required: true,
    },
    customChange: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      paymentsData: [],
      defaultCurrency: localStorage.getItem('defaultCurrency'),
      caseId: this.$route.params.id,
      paymentsLoader: true,
      expandedRowKey: null,
      pdfDownloadRowKey: null,
    }
  },
  computed: {
    paymentsTableFields() {
      return [
        { key: 'id', label: 'ID' },
        { key: 'postingDate', label: i18n.t('DEBTIA_PAYMENT_DATE') },
        { key: 'Amount', label: i18n.t('DEBTIA_AMOUNT') },
        { key: 'type', label: i18n.t('DEBTIA_TYPE') },
      ]
    },
    allocationLogFields() {
      return [
        { key: 'statementName', label: i18n.t('DEBTIA_STATEMENT') },
        { key: 'amountToUs', label: i18n.t('DEBTIA_AMOUNT_TO_US') },
        { key: 'amountToClient', label: i18n.t('DEBTIA_AMOUNT_TO_CLIENT') },
        { key: 'amountApplied', label: i18n.t('DEBTIA_AMOUNT_APPLIED') },
      ]
    },
  },
  created() {
    EventBus.$on('refreshPaymentsWidget', () => {
      this.getPayments()
    })
  },
  methods: {
    rowKey(item) {
      if (!item) {
        return null
      }
      if (item.type === 'Local') {
        return `local-${item.id || item.systemId}`
      }
      return `bc-${item.id || item.systemId}`
    },
    paymentRowClass(item, type) {
      if (type !== 'row' || !item || !this.expandedRowKey) {
        return null
      }
      return this.rowKey(item) === this.expandedRowKey ? 'b-table-row-selected' : null
    },
    statementLinesFor(item) {
      if (!item || !item.statementBreakdown || !item.statementBreakdown.length) {
        return []
      }
      const isEnglish = this.$i18n.locale === 'en'
      return item.statementBreakdown.map(line => ({
        statementName: (isEnglish ? line.enName : line.daName) || line.jobTaskNo,
        amountApplied: this.getDKKConvertedAmount(line.amountApplied),
        amountToUs: this.getDKKConvertedAmount(line.amountToUs),
        amountToClient: this.getDKKConvertedAmount(line.amountToClient),
      }))
    },
    canDownloadFor(item) {
      return Boolean(
        item && item.casePaymentId
          && item.statementBreakdown && item.statementBreakdown.length,
      )
    },
    hasVatReceiptAmount(item) {
      if (!item || !Array.isArray(item.statementBreakdown)) {
        return false
      }
      const amountToUs = item.statementBreakdown.reduce(
        (sum, line) => sum + (parseFloat(line.amountToUs) || 0),
        0,
      )
      return amountToUs > 0
    },
    onPaymentRowClicked(item) {
      const key = this.rowKey(item)
      // Collapse any other currently open row so only the clicked payment shows its allocation panel.
      this.paymentsData.forEach(row => {
        if (row !== item && row[SHOW_DETAILS_KEY]) {
          this.$set(row, SHOW_DETAILS_KEY, false)
        }
      })
      const next = !item[SHOW_DETAILS_KEY]
      this.$set(item, SHOW_DETAILS_KEY, next)
      this.expandedRowKey = next ? key : null
    },
    async fetchInitialData() {
      await this.getPayments()
    },
    async getPayments() {
      this.paymentsLoader = true
      this.expandedRowKey = null
      const url = `${constants.baseUrlV2}/debt-case/payments-data/${this.caseId}`
      try {
        const response = await axios.get(url)
        if (response.status === 200) {
          const rows = Array.isArray(response.data.data) ? response.data.data : []
          this.paymentsData = rows.map(r => (r && typeof r === 'object' ? { ...r } : {}))
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'Payments',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: e.message || 'Failed to load payments',
          },
        })
      } finally {
        this.paymentsLoader = false
      }
    },
    getDKKConvertedAmount(amount) {
      return new Intl.NumberFormat('da-DK', { style: 'currency', currency: this.defaultCurrency }).format(parseFloat(amount).toFixed(2))
    },
    async downloadAllocationPdf(item) {
      if (!this.canDownloadFor(item)) {
        return
      }
      const paymentId = item.casePaymentId
      this.pdfDownloadRowKey = this.rowKey(item)
      const url = `${constants.baseUrl}/debt-case/download-case-payment-pdf/${this.caseId}?paymentId=${encodeURIComponent(paymentId)}`
      try {
        const response = await axios.get(url, { responseType: 'blob' })
        const disposition = response.headers && (response.headers['content-disposition'] || response.headers['Content-Disposition'])
        let fileName = `payment-allocation-${this.caseId}.pdf`
        if (disposition && disposition.indexOf('filename=') !== -1) {
          const [, extractedFileName] = disposition.match(/filename="?([^";]+)"?/i) || []
          if (extractedFileName) {
            fileName = extractedFileName
          }
        }
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = fileName
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(link.href)
      } catch (e) {
        let message = e.message || 'PDF download failed'
        if (e.response && e.response.data instanceof Blob) {
          try {
            const text = await e.response.data.text()
            const parsed = JSON.parse(text)
            if (parsed.message) {
              message = parsed.message
            }
          } catch (ignore) {
            message = 'PDF download failed'
          }
        }
        this.$toast({
          component: ToastificationContent,
          position: 'top-right',
          props: {
            title: 'PDF',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: message,
          },
        })
      } finally {
        this.pdfDownloadRowKey = null
      }
    },
  },
}
</script>

<style lang="scss">
.b-table-row-selected {
  outline: 2px solid var(--primary, #7367f0);
}
</style>
